function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Tooltip from '@homeaway/react-tooltip';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import edapWrapper from '@homeaway/edap-wrapper';
import { SVGDefinitions, SVGIcon } from '@homeaway/react-svg';
import { RadioGroup, RadioButton } from '@homeaway/react-form-components';
import LiveDemo from '../LiveDemo/LiveDemo';
import "./LiveDemoHarness.css";
/* eslint-disable complexity */

var LiveDemoHarness = /*#__PURE__*/function (_Component) {
  _inheritsLoose(LiveDemoHarness, _Component);

  function LiveDemoHarness(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.receiveMessage = function (message) {
      if (message.data && message.data.iframeKey === _this.iframeKey) {
        if (typeof message.data.editorOpen !== 'undefined') {
          _this.setState({
            showCode: message.data.editorOpen
          }, function stateUpdateComplete() {
            this.updateDemoSize(message.data);
          }.bind(_assertThisInitialized(_this)));
        } else {
          _this.updateDemoSize(message.data);
        }
      }
    };

    _this.handleShowCodeClick = function () {
      _this.setState({
        showCode: !_this.state.showCode
      });
    };

    _this.handleToggleClick = function (e) {
      var size = 'lg';

      if (_this.state.demoSize === 'lg') {
        size = 'xs';
      }

      _this.setState({
        demoSize: size,
        mobileOverride: size === 'xs' ? true : false
      });

      edapWrapper().push({
        name: 'generic.click',
        data: {
          eventaction: "demo.viewport." + size,
          eventlabel: e.currentTarget.dataset.demoName
        }
      });
    };

    _this.updateDemoSize = function (message) {
      if (_this.state.showCode) {
        _this.showCodeView(message);
      } else {
        _this.hideCodeView(message);
      }
    };

    _this.handleDemoChange = function (event) {
      var _this$setState;

      var multiDemos = _this.props.multiDemos;
      var index = _this.multidemoKeyIndices[event.target.value];

      if (!_this.state.mobileOverride) {
        _this.setState({
          demoSize: multiDemos[index].demo.demoViews.defaultView
        });
      }

      _this.setState((_this$setState = {}, _this$setState[event.target.name] = multiDemos[index].label, _this$setState.index = index, _this$setState)); // Keep track of a demo change event so render can account for it.


      _this.demoChanged = true;
    };

    _this.multidemoKeyIndices = _this.getKeyIndices(_this.props.multiDemos, _this.props.multiDemoKeys);

    var _index = _this.props.isMultiDemo ? _this.multidemoKeyIndices[0] : 0;

    _this.iframeKey = "liveDemo-" + props.componentName + "-" + props.liveDemoKey;
    _this.state = {
      demoSize: _this.props.demoSize,
      demoHeight: 'auto',
      showCode: false,
      index: _index,
      mobileOverride: false
    };
    _this.editorOpenQueryParam = '';
    _this.editorOpen = _this.state.showCode;
    return _this;
  }

  var _proto = LiveDemoHarness.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (typeof window !== 'undefined' && this.props.useIframe) {
      window.addEventListener('message', this.receiveMessage, false);
    } else if (!this.props.useIframe) {
      // If demos are not in iframe can update the size now.
      this.updateDemoSize();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var sizeUpdate = prevState.demoSize !== this.state.demoSize;
    var needsUpdate = prevState.showCode !== this.state.showCode || sizeUpdate;
    var _this$props = this.props,
        demoSize = _this$props.demoSize,
        componentName = _this$props.componentName,
        isMultiDemo = _this$props.isMultiDemo,
        multiDemos = _this$props.multiDemos,
        multiDemoKeys = _this$props.multiDemoKeys;

    if (demoSize !== prevProps.demoSize) {
      this.setState({
        demoSize: demoSize
      });
    } // Resets default demo props when using multi-demos and switching between component pages


    if (componentName !== prevProps.componentName && isMultiDemo) {
      this.multidemoKeyIndices = this.getKeyIndices(multiDemos, multiDemoKeys);
      var index = this.multidemoKeyIndices[0];
      this.setState({
        index: index,
        showCode: false,
        mobileOverride: false,
        demoSize: multiDemos[index].demo.demoViews.defaultView
      });
    }

    if ((sizeUpdate || needsUpdate) && this.props.useIframe) {
      this.messageIframe();
    } else if (needsUpdate) {
      this.updateDemoSize();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (typeof window !== 'undefined' && this.props.useIframe) {
      window.removeEventListener('message', this.receiveMessage, false);
    }
  }
  /**
   * Builds the indices into the multiDemos array based on the specified
   * multiDemoKeys. Basically, remaps the multiDemos to a key:index object map
   * then builds an array of indices (multidemoKeyIndices) for the requested demos.
   * If no multiDemoKeys were specified then all multiDemos indices are saved.
   */
  ;

  _proto.getKeyIndices = function getKeyIndices(demos, demoKeys) {
    var multidemoKeyIndices = [];

    if (Array.isArray(demos)) {
      if (Array.isArray(demoKeys) && demoKeys.length > 0) {
        var keyIndices = {}; // Map multiDemos to key:index object for quick lookup.

        demos.reduce(function (keyI, demo, i) {
          if (demo.key) {
            keyIndices[demo.key] = i;
          }

          return keyIndices;
        }, keyIndices); // Map the requested demo keys to their indices.

        demoKeys.reduce(function (indices, key) {
          if (typeof keyIndices[key] !== 'undefined') {
            indices.push(keyIndices[key]);
          }

          return indices;
        }, multidemoKeyIndices);
      }

      if (multidemoKeyIndices.length === 0) {
        multidemoKeyIndices = demos.map(function (demo, index) {
          return index;
        });
      }
    }

    return multidemoKeyIndices;
  };

  _proto.messageIframe = function messageIframe() {
    if (this.demoContainer && this.demoContainer.contentWindow && this.demoContainer.contentWindow.postMessage) {
      this.demoContainer.contentWindow.postMessage({
        demoSize: this.state.demoSize,
        editorOpen: this.state.showCode
      }, window.origin);
    }
  };

  _proto.hideCodeView = function hideCodeView(message) {
    if (message && message.previewHeight && message.footerHeight && this.demoContainer) {
      this.demoContainer.style.height = message.previewHeight + message.footerHeight + "px";
    } else if (this.demoContainer) {
      var node = this.props.useIframe ? this.demoContainer.contentWindow.document : this.demoContainer;

      if (node && this.state.demoSize !== 'xs') {
        var livePreview = node.getElementsByClassName('LiveDemo__LivePreview')[0];
        var liveFooter = node.getElementsByClassName('LiveDemo__footer')[0];
        this.demoContainer.style.height = livePreview.clientHeight + liveFooter.clientHeight + "px";
      }
    }
  };

  _proto.showCodeView = function showCodeView(message) {
    if (message && Number.isInteger(message.previewHeight) && Number.isInteger(message.footerHeight) && Number.isInteger(message.editorHeight) && Number.isInteger(message.errorHeight) && this.demoContainer) {
      this.demoContainer.scrollTop = 0;
      this.demoContainer.style.height = message.previewHeight + message.footerHeight + message.editorHeight + message.errorHeight + "px";
    } else if (this.demoContainer) {
      this.demoContainer.scrollTop = 0;
      var node = this.props.useIframe && this.demoContainer ? this.demoContainer.contentWindow.document : this.demoContainer;

      if (node && this.state.demoSize !== 'xs') {
        var livePreview = node.getElementsByClassName('LiveDemo__LivePreview')[0];
        var liveFooter = node.getElementsByClassName('LiveDemo__footer')[0];
        var liveError = node.getElementsByClassName('LiveDemoError')[0];
        var liveEditor = node.getElementsByClassName('LiveDemo__editor')[0];
        var livePreviewHeight = livePreview.clientHeight;
        var liveFooterHeight = liveFooter.clientHeight;
        var liveErrorStyle = getComputedStyle(liveError);
        var liveErrorHeight = liveError.clientHeight + parseInt(liveErrorStyle.marginTop, 10) + parseInt(liveErrorStyle.marginBottom, 10);
        var liveEditorHeight = liveEditor.clientHeight;
        var totalHeight = livePreviewHeight + liveFooterHeight + liveErrorHeight + liveEditorHeight;
        this.demoContainer.style.height = totalHeight + "px";
      }
    }
  } // Used to toggle between different demos if the LiveDemo is a multiDemo
  ;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        componentName = _this$props2.componentName,
        demo = _this$props2.demo,
        multiDemos = _this$props2.multiDemos,
        demoIndex = _this$props2.demoIndex,
        hideChrome = _this$props2.hideChrome,
        local = _this$props2.local,
        repoName = _this$props2.repoName,
        theme = _this$props2.theme,
        minHeight = _this$props2.minHeight,
        owner = _this$props2.owner,
        useIframe = _this$props2.useIframe,
        hideCodeButton = _this$props2.hideCodeButton,
        isMultiDemo = _this$props2.isMultiDemo;
    var _this$props$demoViews = this.props.demoViews,
        defaultView = _this$props$demoViews.defaultView,
        xs = _this$props$demoViews.xs;
    var _this$state = this.state,
        index = _this$state.index,
        showCode = _this$state.showCode,
        demoSize = _this$state.demoSize;
    var scrolling = this.state.showCode ? 'yes' : 'no';
    var srcIndex = isMultiDemo ? index : demoIndex; // The demo index can differ depending on if we are using a single demo or a multiDemo

    var srcView = isMultiDemo ? demoSize : defaultView;
    var demoName = owner + "/" + repoName + "/" + componentName + "/demo/" + srcIndex; // This logic is here to prevent unnecessary reloads of the demo preview
    // when open and closing the code editor while still allowing the switch
    // of the active demo in a multidemo to maintain the editor open state.
    // Basically, only update the query param when the selected demo changes.

    if (this.demoChanged) {
      this.editorOpenQueryParam = "&editorOpen=" + showCode;
      this.demoChanged = false;
    } // TODO: Path (discovery) should be driven from a configuration setting.


    var iframeSrc = local ? "demo.html?name=" + componentName + "&index=" + srcIndex + "&theme=" + theme + "&defaultView=" + srcView + "&hideChrome=" + hideChrome + "&isMultiDemo=" + isMultiDemo + this.editorOpenQueryParam : "/discovery/component/" + demoName + "/" + srcView + "?theme=" + theme + "&hideChrome=" + hideChrome + "&isMultiDemo=" + isMultiDemo + this.editorOpenQueryParam;
    var iframeSrcNewWindow = local ? "demo.html?name=" + componentName + "&index=" + srcIndex + "&theme=" + theme + "&defaultView=lg&editorOpen=true&hideCodeButton=true&isMultiDemo=" + isMultiDemo : "/discovery/component/" + demoName + "/lg?theme=" + theme + "&editorOpen=true&hideCodeButton=true&isMultiDemo=" + isMultiDemo;
    var previewMinHeight = demoSize === 'xs' ? '500px' : minHeight;
    var demoArticleClasses = classnames('LiveDemoHarness__article', {
      'LiveDemoHarness__article--chromeless': hideChrome
    });
    var mobileToggleClass = classnames({
      'text-link': demoSize === 'xs'
    });
    var demoClass = classnames('LiveDemoHarness__demo', {
      'LiveDemoHarness__demo--xs': demoSize === 'xs',
      'LiveDemoHarness__demo--no-code-view': this.state.showCode,
      'LiveDemoHarness--chromeless ': this.props.hideChrome
    });
    var demoStyle = demoSize === 'xs' ? {
      height: '500px'
    } : {
      minHeight: minHeight
    };
    var radioButtonRow = [];

    if (Array.isArray(multiDemos) && this.multidemoKeyIndices.length > 1) {
      radioButtonRow = this.multidemoKeyIndices.map(function (keyIndex, i) {
        return /*#__PURE__*/React.createElement(RadioButton, {
          label: multiDemos[keyIndex].label,
          value: i,
          key: i,
          size: "sm",
          checked: index === keyIndex,
          onChange: _this2.handleDemoChange,
          inline: true
        });
      });
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "LiveDemoHarness",
      ref:
      /* istanbul ignore next */
      function ref(c) {
        return _this2.window = c;
      }
    }, /*#__PURE__*/React.createElement("article", {
      className: demoArticleClasses
    }, !hideChrome && /*#__PURE__*/React.createElement("header", {
      className: "LiveDemoHarness__header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "LiveDemoHarness__header-container"
    }, isMultiDemo && this.multidemoKeyIndices.length > 1 && /*#__PURE__*/React.createElement("div", {
      className: "LiveDemoHarness__header-labels"
    }, /*#__PURE__*/React.createElement("form", {
      className: "LiveDemoHarness__header-labels-form"
    }, /*#__PURE__*/React.createElement(RadioGroup, {
      name: "multiDemoChoice",
      ariaLabel: "Different demo variations"
    }, radioButtonRow))), /*#__PURE__*/React.createElement("div", {
      className: "LiveDemoHarness__toggle-group"
    }, useIframe && /*#__PURE__*/React.createElement(Tooltip, {
      wrapperClassName: "LiveDemoHarness__toggle",
      centered: true,
      content: "Open demo in new window"
    }, /*#__PURE__*/React.createElement(SVGDefinitions, null, /*#__PURE__*/React.createElement("svg", {
      id: "SVG_OPEN_WINDOW__24",
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/React.createElement("g", {
      fill: "none"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M12.5 23.052V10"
    }), /*#__PURE__*/React.createElement("path", {
      strokeLinecap: "square",
      d: "M16 14.016L12 10l-4 4.016"
    }), /*#__PURE__*/React.createElement("path", {
      strokeLinecap: "square",
      d: "M4 17.064H1V1h22v16.064h-3M1 5.502h22"
    })))), /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      href: iframeSrcNewWindow
    }, /*#__PURE__*/React.createElement(SVGIcon, {
      className: "text-default",
      id: "OPEN_WINDOW__24"
    }))), xs && /*#__PURE__*/React.createElement(Tooltip, {
      wrapperClassName: "LiveDemoHarness__toggle",
      centered: true,
      content: "Mobile viewport. 350px"
    }, /*#__PURE__*/React.createElement(SVGDefinitions, null, /*#__PURE__*/React.createElement("svg", {
      id: "SVG_MOBILE__24",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/React.createElement("g", {
      fill: "none"
    }, /*#__PURE__*/React.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M6 2.75h10.5c.83 0 1.5.67 1.5 1.5v17H7.5a1.5 1.5 0 0 1-1.5-1.5V5.67M10.78 5.81h2.5"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      stroke: "none",
      d: "M13.25 18.06a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
    }), /*#__PURE__*/React.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M6 15h12"
    })))), /*#__PURE__*/React.createElement("button", {
      className: 'LiveDemoHarness__toggle-button',
      "data-toggle": "xs",
      "data-demo-name": demoName,
      onClick: this.handleToggleClick
    }, /*#__PURE__*/React.createElement(SVGIcon, {
      className: mobileToggleClass,
      id: "MOBILE__24"
    }))))), isMultiDemo && /*#__PURE__*/React.createElement("div", {
      className: "LiveDemoHarness__description",
      dangerouslySetInnerHTML: {
        __html: multiDemos[this.state.index].description || ''
      }
    })), useIframe && /*#__PURE__*/React.createElement("iframe", {
      className: demoClass,
      "data-iframekey": this.iframeKey,
      frameBorder: "0",
      key: this.iframeKey,
      ref:
      /* istanbul ignore next */
      function ref(c) {
        return _this2.demoContainer = c;
      },
      scrolling: scrolling,
      src: iframeSrc,
      style: demoStyle,
      title: this.iframeKey
    }), !useIframe && isMultiDemo && typeof multiDemos[index] !== 'undefined' && /*#__PURE__*/React.createElement("div", {
      className: demoClass,
      style: demoStyle,
      ref:
      /* istanbul ignore next */
      function ref(c) {
        return _this2.demoContainer = c;
      }
    }, /*#__PURE__*/React.createElement(LiveDemo, {
      clearStyle: multiDemos[index].demo.clearStyle,
      content: multiDemos[index].demo.content,
      demoSize: demoSize,
      hideChrome: hideChrome,
      editorOpen: showCode && demoSize !== 'xs',
      minHeight: previewMinHeight,
      noInline: multiDemos[index].demo.noInline,
      onSizeChange: this.updateDemoSize,
      onShowCodeClicked: this.handleShowCodeClick,
      hideCodeButton: demoSize === 'xs'
    })), !useIframe && isMultiDemo && typeof multiDemos[index] === 'undefined' && /*#__PURE__*/React.createElement("div", {
      className: demoClass,
      style: demoStyle
    }, /*#__PURE__*/React.createElement("p", null, 'Demo not found.')), !useIframe && !isMultiDemo && demo.content && /*#__PURE__*/React.createElement("div", {
      className: demoClass,
      style: demoStyle,
      ref:
      /* istanbul ignore next */
      function ref(c) {
        return _this2.demoContainer = c;
      }
    }, /*#__PURE__*/React.createElement(LiveDemo, {
      clearStyle: demo.clearStyle,
      content: demo.content,
      demoSize: demoSize,
      hideChrome: hideChrome,
      editorOpen: showCode && demoSize !== 'xs',
      minHeight: previewMinHeight,
      noInline: demo.noInline,
      onSizeChange: this.updateDemoSize,
      onShowCodeClicked: this.handleShowCodeClick,
      hideCodeButton: hideCodeButton
    })), !useIframe && !isMultiDemo && !demo.content && /*#__PURE__*/React.createElement("div", {
      className: demoClass,
      style: demoStyle
    }, /*#__PURE__*/React.createElement("p", null, 'Demo not found.'))));
  };

  return LiveDemoHarness;
}(Component);

LiveDemoHarness.propTypes = {
  componentName: PropTypes.string,

  /** The configuration and content for the demo. Required if useIframe is false. */
  demo: PropTypes.shape({
    clearStyle: PropTypes.bool,
    content: PropTypes.string,
    noInline: PropTypes.bool
  }),

  /** The relative viewport size to use for the demo. */
  demoSize: PropTypes.oneOf(['xs', 'lg']),

  /** The default and enabled views for the live demo. */
  demoViews: PropTypes.shape({
    /** The default size for the live demo. */
    defaultView: PropTypes.oneOf(['xs', 'lg']),

    /** Indicates if the lg/desktop viewport should be enabled for the live demo. */
    lg: PropTypes.bool,

    /** Indicates if the xs/mobile viewport should be enabled for the live demo. */
    xs: PropTypes.bool
  }),

  /** The demo number to render for the specified repoName and component name. Required if useIframe is true. */
  demoIndex: PropTypes.number.isRequired,

  /** Indicates whether the UI around the demo should be shown. */
  hideChrome: PropTypes.bool,

  /** Key used for LiveDemoHarness iFrame. */
  liveDemoKey: PropTypes.number.isRequired,

  /** Indicates if the demo reference should be local. Currently only affects the iframe src URL that is referenced. */
  local: PropTypes.bool,

  /** minHeight CSS for the demo container. */
  minHeight: PropTypes.string,

  /** Name of the component being demoed. */
  name: PropTypes.string.isRequired,

  /** The github repository that is associated with the demo. */
  repoName: PropTypes.string.isRequired,

  /** HomeAway Brand theme to use. Only works when useIframe is true. */
  theme: PropTypes.string,

  /** Defines whether the demo is rendered as a separate site in an iframe. If true, requires demoIndex to be specified. */
  useIframe: PropTypes.bool,

  /** */
  multiDemos: PropTypes.arrayOf(PropTypes.shape({
    demo: PropTypes.shape({
      // The demo content
      clearStyle: PropTypes.bool,
      content: PropTypes.string,
      noInline: PropTypes.bool,
      minHeight: PropTypes.string,
      demoViews: PropTypes.shape({
        defaultView: PropTypes.oneOf(['xs', 'lg']),
        lg: PropTypes.bool,
        xs: PropTypes.bool
      })
    }),
    description: PropTypes.html,
    // An HTML string used to describe each demo
    key: PropTypes.string,
    // Unique identifier for the demo.
    label: PropTypes.string // A string used for the multiDemo radio button group labels

  })),

  /** The key labels of multidemos to display. */
  multiDemoKeys: PropTypes.arrayOf(PropTypes.string),

  /** The github repository owner that is associated with the demo. */
  owner: PropTypes.string.isRequired,

  /** Represents whether the LiveDemo we plan to create contains multiple demos or a single demo. */
  isMultiDemo: PropTypes.bool
};
LiveDemoHarness.defaultProps = {
  demo: {},
  demoSize: 'lg',
  demoViews: {
    defaultView: 'lg',
    lg: true,
    xs: true
  },
  hideChrome: false,
  local: false,
  useIframe: true,
  demoIndex: 0,
  isMultiDemo: false
};
export default LiveDemoHarness;
//# sourceMappingURL=LiveDemoHarness.js.map